<template>

    <candidatesContainer class="candidates_container_popup" :pose="visibility">
        <div class="tick-top"></div>
        <div class="candidate_eval_item" v-for="(evaluation) in evaluations" :key="evaluation.id">
            <div class="eval_matching" :class="colorClass(evaluation)">
                <span v-if="evaluation.saven_test.matching_score">{{ evaluation.saven_test.matching_score.toFixed(0) }} %</span>
                <span v-else>-</span>
            </div>
            <router-link :to="'/evaluations/' + evaluation.id" class="eval_name_container">
                <div class="eval_name">
                        {{ evaluation.candidate_username }}
                </div>
            </router-link>

            <div v-if="evaluation.completed" class="eval_reports">
                <div @click="openEvalModal(evaluation.id)" v-if="!evaluation.in_regen">
                    <i class="zmdi zmdi-cloud-download"></i>
                </div>
                <div v-else>
                    <IconLoader class="icon_loader" />
                </div>
            </div>


            <div class="eval_delete" @click="deleteEvalFromPosition(evaluation)" v-if="!notOwnedPosition">
                <iconDelete />
            </div>
            <Modal
                cancelLabel="Fermer"
                :confirmLabel="false"
                :isOpen="evalIsOpened(evaluation.id)"
                :modalTitle="$t('modules.positions.index.positionsList.tableRowEvalModalTitle')"
                class="reports_eval_modal"
                @onConfirm="onConfirm"
                @onClose="onClose">

                <div class="report_choices">

                    <div v-if="evaluation.saven_test.expert_report_url">
                        <a class="button is-info is-outlined" target="_blank" :href="evaluation.saven_test.expert_report_url">
                            {{ $t('modules.positions.index.positionsList.tableRowEvalRecruiterReport') }}
                        </a>
                    </div>
                    <div v-else class="disabled_report_link disabled_in_position">
                        {{ $t('modules.positions.index.positionsList.tableRowEvalRecruiterReport') }}

                    </div>
                    <div v-if="evaluation.saven_test.candidate_report_url">
                        <a class="button is-info is-outlined" target="_blank" :href="evaluation.saven_test.candidate_report_url">
                            {{ $t('modules.positions.index.positionsList.tableRowEvalCandidateReport') }}
                        </a>
                    </div>
                    <div v-else class="disabled_report_link disabled_in_position">
                        {{ $t('modules.positions.index.positionsList.tableRowEvalCandidateReport') }}

                    </div>
                    <div v-if="evaluation.saven_test.manager_report_url">
                        <a class="button is-info is-outlined" target="_blank" :href="evaluation.saven_test.manager_report_url">
                            {{ $t('modules.positions.index.positionsList.tableRowEvalManagerReport') }}
                        </a>
                    </div>
                    <div v-else class="disabled_report_link disabled_in_position">
                        {{ $t('modules.positions.index.positionsList.tableRowEvalManagerReport') }}
                    </div>

                    <div v-if="evaluation.saven_test.customer_report_url">
                        <a class="button is-info is-outlined" target="_blank" :href="evaluation.saven_test.customer_report_url">
                            {{ $t('modules.positions.index.positionsList.tableRowEvalCustomerReport') }}
                        </a>
                    </div>
                    <div v-else class="disabled_report_link disabled_in_position">
                        {{ $t('modules.positions.index.positionsList.tableRowEvalCustomerReport') }}
                    </div>

                    <br>

                    <div class="eval_files_separator"></div>

                    <div class="" v-if="evaluation.docs_ids.length > 0">
                        <div class="eval_file_item" v-for="file in evaluation.docs_ids" :key="file.file_id" >
                            <a class="button is-info is-outlined" target="_blank" :href="file.file_url">
                                {{ file.filename }}
                            </a>
                        </div>
                    </div>

                </div>

            </Modal>
        </div>
    </candidatesContainer>

</template>

<script>
import posed from 'vue-pose';

export default {
    name: 'TablePositionsRowEvalsList',
    props: ['evaluations', 'visibility', 'position'],
    components: {
        candidatesContainer: posed.div({
            visible: {
                opacity: 1,
                x: 0,
                height: 'auto'
            },
            hidden: {
                opacity: 0,
                height: 0
            }
        }),
    },
    mounted(){
        this.checkReportsRegen()
    },
    data(){
        return {
            openedEval: -1,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        notOwnedPosition(){
            return this.userData.id != this.position.user_id
        }
    },
    methods: {
        colorClass(evaluation){
            if(!evaluation.saven_test.matching_score){return 'not_completed'}
            if(evaluation.saven_test.matching_score < 25){return 'low'}
            if(evaluation.saven_test.matching_score >= 25 && evaluation.saven_test.matching_score < 50){return 'middleLow'}
            if(evaluation.saven_test.matching_score >= 50 && evaluation.saven_test.matching_score < 75){return 'middleHigh'}
            if(evaluation.saven_test.matching_score >= 75){return 'high'}
        },
        deleteEvalFromPosition(evaluation){
            this.$emit('deleteEvalFromPosition', evaluation)
        },
        evalIsOpened(evalId){
            return this.openedEval == evalId
        },
        openEvalModal(evalId){
            this.openedEval = evalId
        },
        onClose(){
            this.openedEval = -1
        },
        onConfirm(){

        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.evaluations){
                    const evalsInRegen = this.evaluations.filter((evaluation) => {
                        return evaluation.in_regen
                    })
                    if (evalsInRegen.length > 0){
                        this.$store.dispatch('PositionStore/indexPositions', {})
                    }
                }
            }, 5000)
        }
    },
    beforeDestroy () {
        clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss" >
.candidates_container_popup{
    margin-top: 20px;
    width: 100%;
    border: 1px solid $grey-lighter;
    border-top: none;
    position: relative;
    .tick-top{
        position: absolute;
        top: -10px;
        left: 58px;
        width: 20px;
        height: 20px;
        background-color: $white-ter;
        border-top: 1px solid $grey-lighter;
        border-left: 1px solid $grey-lighter;
        transform: rotateZ(45deg);
        z-index: 1;

    }
    .candidate_eval_item{
        width: 100%;
        display: flex;
        border-top: 1px solid $grey-lighter;
        .eval_matching{
            font-size: 1.25rem;
            height: 50px;
            width: 50px;
            background: $grey-light;
            display: flex;
            justify-content: center;
            align-items: center;
            color: $white;
            letter-spacing: -1px;
            font-weight: 500;
            &.low{
                background-color: $score-diff4;
            }
            &.middleLow{
                background-color: $score-diff3;
            }
            &.middleHigh{
                background-color: $score-diff2;
            }
            &.high{
                background-color: $score-diff1;
            }
        }
        .eval_name_container{
            flex:1;
            background-color: $white-ter;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .eval_name{
                align-items: center;
                padding-left: 12px;
                font-weight: 500;
                color: $grey;
                transition: .3s all;
            }
            &:hover .eval_name{
                color: $info;
            }
        }
        .eval_delete{
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: $white-ter;
            width: 48px;
            svg{
                width: 22px;
                fill: $grey-light;
                transition: .3s all;
            }
            &:hover{
                svg{
                    fill: $danger;
                }
            }
        }
        .eval_reports{
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: $white-ter;
            width: 48px;
            font-size: 1.5rem;
            transition: .3s all;
            &:hover{
                color: $info;
            }
            svg{
                width: 25px;
                cursor: not-allowed!important;
            }
        }
        .report_choices{
            text-align: center;
            a{
                min-width: 250px;
            }
            & > div, .eval_file_item{
                margin-bottom: 8px;
            }

        }
    }
    &.closed{
        margin-top: 0;
    }
}
.disabled_in_position{
    min-width: 250px;
    background: white;
    color: $info;
    display: inline-block;
    margin: 0 8px 12px;
    border: 1px solid $grey-lighter;
    padding: 4px 12px;
    border-radius: 25px;
}
</style>